import { render, staticRenderFns } from "./PublishCourse.vue?vue&type=template&id=19a7319e&scoped=true"
import script from "./PublishCourse.vue?vue&type=script&lang=js"
export * from "./PublishCourse.vue?vue&type=script&lang=js"
import style0 from "./PublishCourse.vue?vue&type=style&index=0&id=19a7319e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a7319e",
  null
  
)

export default component.exports